export const isManualChoice = flowChoice => flowChoice === 'manual';
